import type { NavigateFunction, NavigateOptions } from 'react-router-dom';
import { generatePath } from 'react-router-dom';

export interface SCRouteOptions {
  path: string;
  params?: Record<string, string>;
  searchParams?: Record<string, string> | string | URLSearchParams;
}

const route = {
  _navigate: null as NavigateFunction | null,
  setNavigate: (navigate: NavigateFunction) => {
    route._navigate = navigate;
  },
  getNavigate: () => {
    if (!route._navigate) {
      throw new Error('navigate is not set');
    }
    return route._navigate;
  },
  changeSearchParam: (key: string, value: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    route.getNavigate()(`${url.pathname}${url.search}${url.hash}`);
  },
  generateFullPath: ({ path, params, searchParams }: SCRouteOptions) => {
    const sp = new URLSearchParams(searchParams);
    return `${generatePath(path, params)}${searchParams ? `?${sp.toString()}` : ''}`;
  },
  navigateTo: ({
    path,
    params,
    searchParams,
    options,
  }: SCRouteOptions & {
    options?: NavigateOptions;
  }) => {
    const fullPath = route.generateFullPath({ path, params, searchParams });
    route.getNavigate()(fullPath, options);
  },
};

function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const SCTool = {
  route,
  sleep,
};

export { SCTool };
